module.exports = __webpack_public_path__ + "static/media/kaldt.193a528d.m4a";